import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { IconPowerSolid } from '@roku-web-ui/rds-icons';

import { useAspenSocket } from 'hooks/useAspenSocket';
import { createCommand } from 'modules/aspenCommands';

import { AppDeviceLeaf } from 'types/common/leaf';

import styles from '../overlaysStyle.module.scss';

interface PoweredOffProps {
  leaf: AppDeviceLeaf;
}

export const PoweredOff = ({ leaf }: PoweredOffProps) => {
  const { sendCommand } = useAspenSocket();

  return (
    <Stack
      data-testid="camera-overlay-powered-off"
      direction="column"
      spacing={10}
      alignItems="center"
      justifyContent="center"
    >
      <IconPowerSolid className={styles.defaultIconSize} />
      <Typography variant="h3" className={styles.textSize}>
        Camera is currently off
      </Typography>
      <Button
        aria-label="power"
        data-testid="camera-overlay-button"
        variant="contained"
        onClick={() => {
          sendCommand({
            leaf,
            command: createCommand('power', 'on'),
          });
        }}
      >
        Turn camera on
      </Button>
    </Stack>
  );
};
